import isFinite from 'lodash/isFinite';

import { formatCurrency, getCurrencyPrecision } from '@cast/utils';

export const formatDailyMetricsCost = (
  value?: number,
  approx?: boolean
): string => {
  if (isFinite(value!)) {
    const precision = getCurrencyPrecision(value);
    return `${approx ? '~' : ''}${formatCurrency(value!, {
      maximumFractionDigits: precision,
    })}`;
  }
  return '--.--';
};
